"use client";

import React from "react";
import { Facebook, Twitter, Instagram, Youtube, ArrowUp, Mail, Phone, MapPin, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const CATEGORIES = [{
  label: "Brand Strategy",
  href: "#"
}, {
  label: "Digital Publishing",
  href: "#"
}, {
  label: "Performance Media",
  href: "#"
}, {
  label: "Athlete Marketing",
  href: "#"
}, {
  label: "Content Studio",
  href: "#"
}, {
  label: "Data Analytics",
  href: "#"
}, {
  label: "Global Network",
  href: "#"
}];
const SOCIAL_LINKS = [{
  icon: Twitter,
  href: "#",
  label: "Twitter"
}, {
  icon: Facebook,
  href: "#",
  label: "Facebook"
}, {
  icon: Instagram,
  href: "#",
  label: "Instagram"
}, {
  icon: Youtube,
  href: "#",
  label: "YouTube"
}];
const FALLBACK_COMPANY_LINKS = [{
  label: "Why PIXEL",
  href: "#"
}, {
  label: "Publishing Partners",
  href: "#"
}, {
  label: "Let's Talk!",
  href: "#"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3].map((_, i) => <li key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded-md" />)}
      </ul>;
  }
  const linksToRender = menuItems && menuItems.length > 0 ? menuItems : FALLBACK_COMPANY_LINKS;
  return <ul className="space-y-3">
      {linksToRender.map((item, i) => <li key={item.id || i} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-1 group font-sans text-sm">
            <ChevronRight className="size-3 opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300" />
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Privacypolicyfooter() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  return;
}